import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JL } from 'jsnlog';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class SharedService {
  JL: JL.JSNLog;
  WebURL: string = "";

  constructor(public http: HttpClient) {
    //this.JL = JL;
  }

  public loadConfig() {
    if (!this.WebURL) {
      this.http.get<string>('api/User/GetAPIURL').subscribe(res => {
        this.WebURL = res;
      });
    }
  }

  // Loading variables
  public loadingBehaviorSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingBehaviorSubject.asObservable();

  public transaction = new BehaviorSubject<boolean>(false);
  public transaction$ = this.transaction.asObservable();
}
